import toast from "react-hot-toast";

export const showToast = (action: string) => {
    if (action === "create") toast.success("Successfully created", { duration: 3000 });
    if (action === "update") toast.success("Successfully updated", { duration: 3000 });
    if (action === "delete") toast.success("Successfully deleted", { duration: 3000 });
};